import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { IconButton, Stack, useMediaQuery, Typography, Container, Button } from '@mui/material';
import LaunchButton from 'components/Buttons/LaunchButton';
import MenuIcon from '@mui/icons-material/Menu';

// project imports
import LogoSection from '../LogoSection';
// import { Link } from 'react-router-dom';
// import pdfToDownload from '../../../assets/TaralLitepaper.pdf';
// assets
// import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const LinkButton = ({ children, ...props }) => (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.2}
      sx={{
        cursor: 'pointer',
        color: 'text.secondary',
        '&:hover': { color: 'text.primary' }
      }}
      {...props}
    >
      {children}
    </Stack>
  );
  return (
    <>
      {/* logo & toggler button */}
      <Container maxWidth="xl" sx={{ padding: '10px 0px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap">
          {/* Logo */}
          <LogoSection />

          {/* Action Buttons */}
          {isMobile ? (
            <IconButton
              onClick={() => {
                handleLeftDrawerToggle();
              }}
            >
              <MenuIcon sx={{ color: 'text.secondary' }} />
            </IconButton>
          ) : (
            <Stack direction="row" spacing={5} alignItems="center">
              {/* Links */}
              {!isMobile && (
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={6} sx={{ flex: 1 }} flexWrap="wrap">
                  <LinkButton>
                    <Typography
                      onClick={() => {
                        window.open('https://taraldocs.tarality.com/getting-started/developer-guide', '_blank');
                      }}
                      variant="body2"
                    >
                      Developers Docs
                    </Typography>
                  </LinkButton>

                  <LinkButton>
                    <Typography
                      onClick={() => {
                        window.open('https://taraldocs.tarality.com/getting-started/developer-guide/nodes-and-validators', '_blank');
                      }}
                      variant="body2"
                    >
                      Become Validator
                    </Typography>
                  </LinkButton>
                </Stack>
              )}
              <LaunchButton
                btnName={'Join the Community'}
                sx={{ borderRadius: 3 }}
                onClick={() => {
                  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                }}
              />

              <Button
                variant="text"
                sx={{
                  backgroundColor: '#fff',
                  px: 4,
                  ':hover': {
                    backgroundColor: '#2196f3'
                  }
                }}
              >
                <a style={{ textDecoration: 'none', color: '#000000', fontWeight: '600' }} href={'/images/TaralLitepaper.pdf'} download>
                  Download Litepaper
                </a>
              </Button>
            </Stack>
          )}
        </Stack>

        {/* <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              '&:hover': {
                background: theme.palette.secondary.dark,
                color: theme.palette.secondary.light
              }
            }}
            onClick={handleLeftDrawerToggle}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase> */}
      </Container>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
